export const TIMEZONES_UTC = [
  { label: "UTC−12:00", country: "International Date Line West", timezone: "Etc/GMT+12" },

  { label: "UTC−11:00", country: "American Samoa", timezone: "Pacific/Pago_Pago" },
  { label: "UTC−11:00", country: "Niue", timezone: "Pacific/Niue" },
  { label: "UTC−11:00", country: "United States", timezone: "Pacific/Midway" },

  { label: "UTC−10:00", country: "United States", timezone: "Pacific/Honolulu" },
  { label: "UTC−10:00", country: "French Polynesia", timezone: "Pacific/Tahiti" },
  { label: "UTC−10:00", country: "Cook Islands", timezone: "Pacific/Rarotonga" },
  { label: "UTC−10:00", country: "Kiribati", timezone: "Pacific/Fakaofo" },

  { label: "UTC−09:00", country: "United States", timezone: "America/Anchorage" },
  { label: "UTC−09:00", country: "French Polynesia", timezone: "Pacific/Gambier" },
  { label: "UTC−09:00", country: "Canada", timezone: "America/Juneau" },
  { label: "UTC−09:00", country: "Canada", timezone: "America/Metlakatla" },
  { label: "UTC−09:00", country: "Canada", timezone: "America/Nome" },
  { label: "UTC−09:00", country: "Canada", timezone: "America/Yakutat" },

  { label: "UTC−08:00", country: "United States", timezone: "America/Los_Angeles" },
  { label: "UTC−08:00", country: "Canada", timezone: "America/Vancouver" },
  { label: "UTC−08:00", country: "United Kingdom", timezone: "Pacific/Pitcairn" },
  { label: "UTC−08:00", country: "Mexico", timezone: "America/Tijuana" },

  { label: "UTC−07:00", country: "United States", timezone: "America/Denver" },
  { label: "UTC−07:00", country: "United States", timezone: "America/Phoenix" },
  { label: "UTC−07:00", country: "Canada", timezone: "America/Edmonton" },
  { label: "UTC−07:00", country: "Mexico", timezone: "America/Chihuahua" },
  { label: "UTC−07:00", country: "Mexico", timezone: "America/Mazatlan" },
  { label: "UTC−07:00", country: "Canada", timezone: "America/Cambridge Bay" },
  { label: "UTC−07:00", country: "Canada", timezone: "America/Yellowknife" },
  { label: "UTC−07:00", country: "Canada", timezone: "America/Inuvik" },
  { label: "UTC−07:00", country: "Mexico", timezone: "America/Ojinaga" },

  { label: "UTC−06:00", country: "United States", timezone: "America/Chicago" },
  { label: "UTC−06:00", country: "Mexico", timezone: "America/Mexico_City" },
  { label: "UTC−06:00", country: "Guatemala", timezone: "America/Guatemala" },
  { label: "UTC−06:00", country: "Costa Rica", timezone: "America/Costa_Rica" },
  { label: "UTC−06:00", country: "El Salvador", timezone: "America/El_Salvador" },
  { label: "UTC−06:00", country: "Honduras", timezone: "America/Tegucigalpa" },
  { label: "UTC−06:00", country: "Nicaragua", timezone: "America/Managua" },
  { label: "UTC−06:00", country: "Canada", timezone: "America/Winnipeg" },
  { label: "UTC−06:00", country: "Canada", timezone: "America/Rainy_River" },
  { label: "UTC−06:00", country: "Canada", timezone: "America/Rankin_Inlet" },
  { label: "UTC−06:00", country: "Canada", timezone: "America/Resolute" },
  { label: "UTC−06:00", country: "Mexico", timezone: "America/Cancun" },
  { label: "UTC−06:00", country: "Mexico", timezone: "America/Merida" },
  { label: "UTC−06:00", country: "Mexico", timezone: "America/Monterrey" },
  { label: "UTC−06:00", country: "Mexico", timezone: "America/Matamoros" },
  { label: "UTC−06:00", country: "Mexico", timezone: "America/Bahia Banderas" },

  { label: "UTC−05:00", country: "United States", timezone: "America/New_York" },
  { label: "UTC−05:00", country: "Canada", timezone: "America/Toronto" },
  { label: "UTC−05:00", country: "Peru", timezone: "America/Lima" },
  { label: "UTC−05:00", country: "Colombia", timezone: "America/Bogota" },
  { label: "UTC−05:00", country: "Ecuador", timezone: "America/Guayaquil" },
  { label: "UTC−05:00", country: "Jamaica", timezone: "America/Jamaica" },
  { label: "UTC−05:00", country: "Cuba", timezone: "America/Havana" },
  { label: "UTC−05:00", country: "Panama", timezone: "America/Panama" },
  { label: "UTC−05:00", country: "Bahamas", timezone: "America/Nassau" },
  { label: "UTC−05:00", country: "Haiti", timezone: "America/Port-au-Prince" },
  { label: "UTC−05:00", country: "Turks and Caicos Islands", timezone: "America/Grand_Turk" },
  { label: "UTC−05:00", country: "Canada", timezone: "America/Nipigon" },
  { label: "UTC−05:00", country: "Canada", timezone: "America/Thunder_Bay" },
  { label: "UTC−05:00", country: "Canada", timezone: "America/Iqaluit" },
  { label: "UTC−05:00", country: "Canada", timezone: "America/Pangnirtung" },

  { label: "UTC−04:00", country: "Chile", timezone: "America/Santiago" },
  { label: "UTC−04:00", country: "Venezuela", timezone: "America/Caracas" },
  { label: "UTC−04:00", country: "Canada", timezone: "America/Halifax" },
  { label: "UTC−04:00", country: "Bolivia", timezone: "America/La_Paz" },
  { label: "UTC−04:00", country: "Paraguay", timezone: "America/Asuncion" },
  { label: "UTC−04:00", country: "Dominican Republic", timezone: "America/Santo_Domingo" },
  { label: "UTC−04:00", country: "Puerto Rico", timezone: "America/Puerto_Rico" },
  { label: "UTC−04:00", country: "Barbados", timezone: "America/Barbados" },
  { label: "UTC−04:00", country: "Trinidad & Tobago", timezone: "America/Port_of_Spain" },
  { label: "UTC−04:00", country: "Grenada", timezone: "America/Grenada" },
  { label: "UTC−04:00", country: "Saint Vincent and the Grenadines", timezone: "America/St_Vincent" },
  { label: "UTC−04:00", country: "Dominica", timezone: "America/Dominica" },
  { label: "UTC−04:00", country: "Saint Lucia", timezone: "America/St_Lucia" },
  { label: "UTC−04:00", country: "Antigua and Barbuda", timezone: "America/Antigua" },
  { label: "UTC−04:00", country: "Saint Kitts and Nevis", timezone: "America/St_Kitts" },
  { label: "UTC−04:00", country: "Canada", timezone: "America/Glace_Bay" },
  { label: "UTC−04:00", country: "Canada", timezone: "America/Goose_Bay" },
  { label: "UTC−04:00", country: "Canada", timezone: "America/Moncton" },
  { label: "UTC−04:00", country: "Canada", timezone: "America/Blanc-Sablon" },
  { label: "UTC−04:00", country: "Bermuda", timezone: "Atlantic/Bermuda" },
  { label: "UTC−04:00", country: "Greenland", timezone: "America/Danmarkshavn" },
  { label: "UTC−04:00", country: "Greenland", timezone: "America/Scoresbysund" },
  { label: "UTC−04:00", country: "Greenland", timezone: "America/Thule" },

  { label: "UTC−03:00", country: "Argentina", timezone: "America/Argentina/Buenos_Aires" },
  { label: "UTC−03:00", country: "Brazil", timezone: "America/Sao_Paulo" },
  { label: "UTC−03:00", country: "Uruguay", timezone: "America/Montevideo" },
  { label: "UTC−03:00", country: "Suriname", timezone: "America/Paramaribo" },
  { label: "UTC−03:00", country: "French Guiana", timezone: "America/Cayenne" },
  { label: "UTC−03:00", country: "Greenland", timezone: "America/Godthab" },
  { label: "UTC−03:00", country: "Falkland Islands", timezone: "Atlantic/Stanley" },
  { label: "UTC−03:00", country: "Brazil", timezone: "America/Maceio" },
  { label: "UTC−03:00", country: "Brazil", timezone: "America/Bahia" },
  { label: "UTC−03:00", country: "Brazil", timezone: "America/Recife" },
  { label: "UTC−03:00", country: "Brazil", timezone: "America/Fortaleza" },
  { label: "UTC−03:00", country: "Brazil", timezone: "America/Araguaina" },
  { label: "UTC−03:00", country: "Brazil", timezone: "America/Belem" },
  { label: "UTC−03:00", country: "Brazil", timezone: "America/Manaus" },
  { label: "UTC−03:00", country: "Brazil", timezone: "America/Cuiaba" },
  { label: "UTC−03:00", country: "Brazil", timezone: "America/Santarem" },
  { label: "UTC−03:00", country: "Chile", timezone: "America/Punta_Arenas" },

  { label: "UTC−02:00", country: "Brazil", timezone: "America/Noronha" },
  { label: "UTC−02:00", country: "United Kingdom", timezone: "Atlantic/South_Georgia" },
  { label: "UTC−02:00", country: "South Georgia and the South Sandwich Islands", timezone: "Atlantic/South_Georgia" },

  { label: "UTC−01:00", country: "Azores", timezone: "Atlantic/Azores" },
  { label: "UTC−01:00", country: "Portugal", timezone: "Atlantic/Azores" },
  { label: "UTC−01:00", country: "Cape Verde", timezone: "Atlantic/Cape_Verde" },
  { label: "UTC−01:00", country: "Greenland", timezone: "America/Scoresbysund" },

  { label: "UTC±00:00", country: "United Kingdom", timezone: "Europe/London" },
  { label: "UTC±00:00", country: "Ireland", timezone: "Europe/Dublin" },
  { label: "UTC±00:00", country: "Ivory Coast", timezone: "Africa/Abidjan" },
  { label: "UTC±00:00", country: "Iceland", timezone: "Atlantic/Reykjavik" },
  { label: "UTC±00:00", country: "Portugal", timezone: "Atlantic/Madeira" },
  { label: "UTC±00:00", country: "Ghana", timezone: "Africa/Accra" },
  { label: "UTC±00:00", country: "Senegal", timezone: "Africa/Dakar" },
  { label: "UTC±00:00", country: "Morocco", timezone: "Africa/Casablanca" },
  { label: "UTC±00:00", country: "Nigeria", timezone: "Africa/Lagos" },
  { label: "UTC±00:00", country: "Mali", timezone: "Africa/Bamako" },
  { label: "UTC±00:00", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { label: "UTC±00:00", country: "Mauritania", timezone: "Africa/Nouakchott" },
  { label: "UTC±00:00", country: "Sierra Leone", timezone: "Africa/Freetown" },
  { label: "UTC±00:00", country: "Liberia", timezone: "Africa/Monrovia" },
  { label: "UTC±00:00", country: "Guinea", timezone: "Africa/Conakry" },
  { label: "UTC±00:00", country: "Greenland", timezone: "America/Danmarkshavn" },

  { label: "UTC+01:00", country: "Germany", timezone: "Europe/Berlin" },
  { label: "UTC+01:00", country: "France", timezone: "Europe/Paris" },
  { label: "UTC+01:00", country: "Spain", timezone: "Europe/Madrid" },
  { label: "UTC+01:00", country: "Nigeria", timezone: "Africa/Lagos" },
  { label: "UTC+01:00", country: "Italy", timezone: "Europe/Rome" },
  { label: "UTC+01:00", country: "Poland", timezone: "Europe/Warsaw" },
  { label: "UTC+01:00", country: "Sweden", timezone: "Europe/Stockholm" },
  { label: "UTC+01:00", country: "Norway", timezone: "Europe/Oslo" },
  { label: "UTC+01:00", country: "Algeria", timezone: "Africa/Algiers" },
  { label: "UTC+01:00", country: "Tunisia", timezone: "Africa/Tunis" },
  { label: "UTC+01:00", country: "Hungary", timezone: "Europe/Budapest" },
  { label: "UTC+01:00", country: "Czech Republic", timezone: "Europe/Prague" },
  { label: "UTC+01:00", country: "Slovakia", timezone: "Europe/Bratislava" },
  { label: "UTC+01:00", country: "Croatia", timezone: "Europe/Zagreb" },
  { label: "UTC+01:00", country: "Slovenia", timezone: "Europe/Ljubljana" },
  { label: "UTC+01:00", country: "Serbia", timezone: "Europe/Belgrade" },
  { label: "UTC+01:00", country: "North Macedonia", timezone: "Europe/Skopje" },
  { label: "UTC+01:00", country: "Bosnia and Herzegovina", timezone: "Europe/Sarajevo" },
  { label: "UTC+01:00", country: "Montenegro", timezone: "Europe/Podgorica" },
  { label: "UTC+01:00", country: "Denmark", timezone: "Europe/Copenhagen" },
  { label: "UTC+01:00", country: "Belgium", timezone: "Europe/Brussels" },
  { label: "UTC+01:00", country: "Netherlands", timezone: "Europe/Amsterdam" },
  { label: "UTC+01:00", country: "Luxembourg", timezone: "Europe/Luxembourg" },
  { label: "UTC+01:00", country: "Switzerland", timezone: "Europe/Zurich" },
  { label: "UTC+01:00", country: "Austria", timezone: "Europe/Vienna" },
  { label: "UTC+01:00", country: "Monaco", timezone: "Europe/Monaco" },
  { label: "UTC+01:00", country: "Liechtenstein", timezone: "Europe/Vaduz" },
  { label: "UTC+01:00", country: "Andorra", timezone: "Europe/Andorra" },
  { label: "UTC+01:00", country: "San Marino", timezone: "Europe/San_Marino" },
  { label: "UTC+01:00", country: "Vatican City", timezone: "Europe/Vatican" },
  { label: "UTC+01:00", country: "Cameroon", timezone: "Africa/Douala" },
  { label: "UTC+01:00", country: "Chad", timezone: "Africa/Ndjamena" },
  { label: "UTC+01:00", country: "Central African Republic", timezone: "Africa/Bangui" },
  { label: "UTC+01:00", country: "Republic of the Congo", timezone: "Africa/Brazzaville" },
  { label: "UTC+01:00", country: "Democratic Republic of the Congo", timezone: "Africa/Kinshasa" },
  { label: "UTC+01:00", country: "Gabon", timezone: "Africa/Libreville" },
  { label: "UTC+01:00", country: "Equatorial Guinea", timezone: "Africa/Malabo" },
  { label: "UTC+01:00", country: "Angola", timezone: "Africa/Luanda" },
  { label: "UTC+01:00", country: "São Tomé and Príncipe", timezone: "Africa/Sao_Tome" },
  { label: "UTC+01:00", country: "Albania", timezone: "Europe/Tirane" },
  { label: "UTC+01:00", country: "Kosovo", timezone: "Europe/Pristina" },
  { label: "UTC+01:00", country: "Malta", timezone: "Europe/Malta" },

  { label: "UTC+02:00", country: "Greece", timezone: "Europe/Athens" },
  { label: "UTC+02:00", country: "Romania", timezone: "Europe/Bucharest" },
  { label: "UTC+02:00", country: "Egypt", timezone: "Africa/Cairo" },
  { label: "UTC+02:00", country: "South Africa", timezone: "Africa/Johannesburg" },
  { label: "UTC+02:00", country: "Finland", timezone: "Europe/Helsinki" },
  { label: "UTC+02:00", country: "Israel", timezone: "Asia/Jerusalem" },
  { label: "UTC+02:00", country: "Turkey", timezone: "Europe/Istanbul" },
  { label: "UTC+02:00", country: "Ukraine", timezone: "Europe/Kiev" },
  { label: "UTC+02:00", country: "Bulgaria", timezone: "Europe/Sofia" },
  { label: "UTC+02:00", country: "Libya", timezone: "Africa/Tripoli" },
  { label: "UTC+02:00", country: "Zambia", timezone: "Africa/Lusaka" },
  { label: "UTC+02:00", country: "Zimbabwe", timezone: "Africa/Harare" },
  { label: "UTC+02:00", country: "Malawi", timezone: "Africa/Blantyre" },
  { label: "UTC+02:00", country: "Mozambique", timezone: "Africa/Maputo" },
  { label: "UTC+02:00", country: "Botswana", timezone: "Africa/Gaborone" },
  { label: "UTC+02:00", country: "Eswatini", timezone: "Africa/Mbabane" },
  { label: "UTC+02:00", country: "Lesotho", timezone: "Africa/Maseru" },
  { label: "UTC+02:00", country: "Jordan", timezone: "Asia/Amman" },
  { label: "UTC+02:00", country: "Lebanon", timezone: "Asia/Beirut" },
  { label: "UTC+02:00", country: "Syria", timezone: "Asia/Damascus" },

  { label: "UTC+03:00", country: "Russia", timezone: "Europe/Moscow" },
  { label: "UTC+03:00", country: "Kenya", timezone: "Africa/Nairobi" },
  { label: "UTC+03:00", country: "Saudi Arabia", timezone: "Asia/Riyadh" },
  { label: "UTC+03:00", country: "Iraq", timezone: "Asia/Baghdad" },
  { label: "UTC+03:00", country: "Bahrain", timezone: "Asia/Bahrain" },
  { label: "UTC+03:00", country: "Qatar", timezone: "Asia/Qatar" },
  { label: "UTC+03:00", country: "Turkey", timezone: "Europe/Istanbul" },
  { label: "UTC+03:00", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { label: "UTC+03:00", country: "Tanzania", timezone: "Africa/Dar_es_Salaam" },
  { label: "UTC+03:00", country: "Uganda", timezone: "Africa/Kampala" },
  { label: "UTC+03:00", country: "Somalia", timezone: "Africa/Mogadishu" },
  { label: "UTC+03:00", country: "Madagascar", timezone: "Indian/Antananarivo" },
  { label: "UTC+03:00", country: "Comoros", timezone: "Indian/Comoro" },
  { label: "UTC+03:00", country: "Mayotte", timezone: "Indian/Mayotte" },
  { label: "UTC+03:00", country: "Azerbaijan", timezone: "Asia/Baku" },
  { label: "UTC+03:00", country: "Armenia", timezone: "Asia/Yerevan" },
  { label: "UTC+03:00", country: "Georgia", timezone: "Asia/Tbilisi" },

  { label: "UTC+03:30", country: "Iran", timezone: "Asia/Tehran" },

  { label: "UTC+04:00", country: "United Arab Emirates", timezone: "Asia/Dubai" },
  { label: "UTC+04:00", country: "Russia", timezone: "Europe/Samara" },
  { label: "UTC+04:00", country: "Azerbaijan", timezone: "Asia/Baku" },
  { label: "UTC+04:00", country: "Georgia", timezone: "Asia/Tbilisi" },
  { label: "UTC+04:00", country: "Armenia", timezone: "Asia/Yerevan" },
  { label: "UTC+04:00", country: "Mauritius", timezone: "Indian/Mauritius" },
  { label: "UTC+04:00", country: "Seychelles", timezone: "Indian/Mahe" },
  { label: "UTC+04:00", country: "Oman", timezone: "Asia/Muscat" },

  { label: "UTC+04:30", country: "Afghanistan", timezone: "Asia/Kabul" },

  { label: "UTC+05:00", country: "Pakistan", timezone: "Asia/Karachi" },
  { label: "UTC+05:00", country: "Russia", timezone: "Asia/Yekaterinburg" },
  { label: "UTC+05:00", country: "Uzbekistan", timezone: "Asia/Tashkent" },
  { label: "UTC+05:00", country: "Turkmenistan", timezone: "Asia/Ashgabat" },
  { label: "UTC+05:00", country: "Maldives", timezone: "Indian/Maldives" },
  { label: "UTC+05:00", country: "Tajikistan", timezone: "Asia/Dushanbe" },

  { label: "UTC+05:30", country: "India", timezone: "Asia/Kolkata" },
  { label: "UTC+05:30", country: "Sri Lanka", timezone: "Asia/Colombo" },

  { label: "UTC+05:45", country: "Nepal", timezone: "Asia/Kathmandu" },

  { label: "UTC+06:00", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { label: "UTC+06:00", country: "Kazakhstan", timezone: "Asia/Almaty" },
  { label: "UTC+06:00", country: "Bhutan", timezone: "Asia/Thimphu" },
  { label: "UTC+06:00", country: "Kyrgyzstan", timezone: "Asia/Bishkek" },
  { label: "UTC+06:00", country: "Kazakhstan", timezone: "Asia/Qyzylorda" },

  { label: "UTC+06:30", country: "Myanmar", timezone: "Asia/Yangon" },
  { label: "UTC+06:30", country: "Cocos (Keeling) Islands", timezone: "Indian/Cocos" },

  { label: "UTC+07:00", country: "Thailand", timezone: "Asia/Bangkok" },
  { label: "UTC+07:00", country: "Indonesia", timezone: "Asia/Jakarta" },
  { label: "UTC+07:00", country: "Vietnam", timezone: "Asia/Ho_Chi_Minh" },
  { label: "UTC+07:00", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { label: "UTC+07:00", country: "Laos", timezone: "Asia/Vientiane" },
  { label: "UTC+07:00", country: "Mongolia", timezone: "Asia/Ulaanbaatar" },
  { label: "UTC+07:00", country: "Russia", timezone: "Asia/Novosibirsk" },
  { label: "UTC+07:00", country: "Russia", timezone: "Asia/Omsk" },

  { label: "UTC+08:00", country: "China", timezone: "Asia/Shanghai" },
  { label: "UTC+08:00", country: "Singapore", timezone: "Asia/Singapore" },
  { label: "UTC+08:00", country: "Australia", timezone: "Australia/Perth" },
  { label: "UTC+08:00", country: "Malaysia", timezone: "Asia/Kuala_Lumpur" },
  { label: "UTC+08:00", country: "Philippines", timezone: "Asia/Manila" },
  { label: "UTC+08:00", country: "Hong Kong", timezone: "Asia/Hong Kong" },
  { label: "UTC+08:00", country: "Taiwan", timezone: "Asia/Taipei" },
  { label: "UTC+08:00", country: "Brunei", timezone: "Asia/Brunei" },
  { label: "UTC+08:00", country: "Mongolia", timezone: "Asia/Choibalsan" },
  { label: "UTC+08:00", country: "Russia", timezone: "Asia/Irkutsk" },
  { label: "UTC+08:00", country: "Russia", timezone: "Asia/Ust-Nera" },

  { label: "UTC+08:45", country: "Australia", timezone: "Australia/Eucla" },

  { label: "UTC+09:00", country: "Japan", timezone: "Asia/Tokyo" },
  { label: "UTC+09:00", country: "South Korea", timezone: "Asia/Seoul" },
  { label: "UTC+09:00", country: "East Timor", timezone: "Asia/Dili" },
  { label: "UTC+09:00", country: "Palau", timezone: "Pacific/Palau" },
  { label: "UTC+09:00", country: "Russia", timezone: "Asia/Yakutsk" },
  { label: "UTC+09:00", country: "Russia", timezone: "Asia/Khandyga" },
  { label: "UTC+09:00", country: "Indonesia", timezone: "Asia/Jayapura" },

  { label: "UTC+09:30", country: "Australia", timezone: "Australia/Darwin" },
  { label: "UTC+09:30", country: "Australia", timezone: "Australia/Adelaide" },

  { label: "UTC+10:00", country: "Australia", timezone: "Australia/Sydney" },
  { label: "UTC+10:00", country: "Papua New Guinea", timezone: "Pacific/Port_Moresby" },
  { label: "UTC+10:00", country: "Guam", timezone: "Pacific/Guam" },
  { label: "UTC+10:00", country: "Federated States of Micronesia", timezone: "Pacific/Chuuk" },
  { label: "UTC+10:00", country: "Russia", timezone: "Asia/Vladivostok" },

  { label: "UTC+10:30", country: "Australia", timezone: "Australia/Lord_Howe" },

  { label: "UTC+11:00", country: "New Caledonia", timezone: "Pacific/Noumea" },
  { label: "UTC+11:00", country: "Solomon Islands", timezone: "Pacific/Guadalcanal" },
  { label: "UTC+11:00", country: "Vanuatu", timezone: "Pacific/Efate" },

  { label: "UTC+12:00", country: "New Zealand", timezone: "Pacific/Auckland" },
  { label: "UTC+12:00", country: "Fiji", timezone: "Pacific/Fiji" },
  { label: "UTC+12:00", country: "Tuvalu", timezone: "Pacific/Funafuti" },
  { label: "UTC+12:00", country: "Nauru", timezone: "Pacific/Nauru" },
  { label: "UTC+12:00", country: "Marshall Islands", timezone: "Pacific/Majuro" },
  { label: "UTC+12:00", country: "Kiribati", timezone: "Pacific/Kwajalein" },

  { label: "UTC+12:45", country: "New Zealand", timezone: "Pacific/Chatham" },

  { label: "UTC+13:00", country: "Tonga", timezone: "Pacific/Tongatapu" },
  { label: "UTC+13:00", country: "Samoa", timezone: "Pacific/Apia" },
  { label: "UTC+13:00", country: "Kiribati", timezone: "Pacific/Enderbury" },

  { label: "UTC+14:00", country: "Kiribati", timezone: "Pacific/Kiritimati" },
];
